import React from 'react';
import { AppEmptyState } from '../ui';
import '../../styles/kkp-planning-page.scss';

/**
 * Empty / loading unifiés pour les plannings ventes.
 */
const KkpPlanningEmptyState = ({
  loading = false,
  message = 'Aucun résultat pour ces filtres.',
  actions = [],
}) => (
  <AppEmptyState
    loading={loading}
    message={message}
    actions={actions}
    icon="mdi:table-large-remove"
  />
);

export default KkpPlanningEmptyState;
